var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, } from '@one-thd/sui-atomic-components';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { useCommonContext } from '../../../hooks/useContexts';
import { CustomDateRange } from '../../shared/CustomDateRange';
import { DateSelectionDropdown } from '../../shared/DateSelectionDropdown';
import { SearchBy, SortBy } from './index';
var isApplyDisabled = function (startDate, endDate) {
    if (((startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '') === '' &&
        ((endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '') === '')
        return true;
    if (startDate &&
        (startDate === null || startDate === void 0 ? void 0 : startDate.startOf('day')) <
            DateTime.now().minus({ months: 25 }).startOf('day'))
        return true;
    if (endDate && (endDate === null || endDate === void 0 ? void 0 : endDate.startOf('day')) > DateTime.now().startOf('day'))
        return true;
    return false;
};
export var SortAndSearchButton = function (_a) {
    var customerType = _a.customerType, dateSelectorValue = _a.dateSelectorValue, isMobile = _a.isMobile, pHRequest = _a.pHRequest, setDateSelectorValue = _a.setDateSelectorValue, setPHRequest = _a.setPHRequest;
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(0), drawerStepper = _c[0], setDrawerStepper = _c[1];
    var _d = useState(null), startDate = _d[0], setStartDate = _d[1];
    var _e = useState(null), endDate = _e[0], setEndDate = _e[1];
    var setDateRangeOptions = useCommonContext().setDateRangeOptions;
    var dateRangeState = {
        startDate: startDate,
        endDate: endDate,
        open: open,
        setEndDate: setEndDate,
        setStartDate: setStartDate,
        dateSelectorValue: dateSelectorValue,
        setOpen: setOpen,
    };
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "primary", onClick: function () { return handleOpen(); } }, "Sort & Search"),
        React.createElement(Drawer, { open: open, onClose: handleClose, style: { zIndex: 2000000009 } },
            drawerStepper === 0 ? (React.createElement(DrawerHeader, { title: "Sort & Search", onClose: handleClose })) : (React.createElement(DrawerHeader, { title: "Custom Date Range", onClose: function () {
                    handleClose();
                    setDrawerStepper(0);
                }, onBack: function () {
                    setDateSelectorValue('recentOrders');
                    setDrawerStepper(0);
                } })),
            React.createElement(DrawerBody, null,
                React.createElement("div", { style: { minHeight: 400 } },
                    drawerStepper === 0 && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "sui-pb-[24px]" },
                            React.createElement(SortBy, { pHRequest: pHRequest, setPHRequest: setPHRequest, handleClose: handleClose })),
                        React.createElement("div", { className: "sui-pb-[24px]" },
                            React.createElement(DateSelectionDropdown, { label: "View History From", dateSelectorValue: dateSelectorValue, setDateSelectorValue: setDateSelectorValue, setPHRequest: setPHRequest, enableFullWidth: true, handleModalClose: handleClose, setDrawerStepper: setDrawerStepper })),
                        React.createElement(SearchBy, { customerType: customerType, pHRequest: pHRequest, setPHRequest: setPHRequest, isMobile: isMobile, handleClose: handleClose }))),
                    drawerStepper === 1 && (React.createElement(CustomDateRange, { dateRangeState: dateRangeState })))),
            drawerStepper === 1 && (React.createElement(DrawerFooter, { position: "end" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
                    React.createElement(Button, { variant: "primary", disabled: isApplyDisabled(startDate, endDate), onClick: function () {
                            if (setDateRangeOptions) {
                                setDateRangeOptions({
                                    startDate: (startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '',
                                    endDate: (endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '',
                                });
                                if (setPHRequest) {
                                    setPHRequest(function (prevState) {
                                        return __assign(__assign({}, prevState), { startDate: (startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '', endDate: (endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '', pageNumber: 1 });
                                    });
                                }
                                setDrawerStepper(0);
                                setOpen(false);
                            }
                        } }, "Apply"),
                    React.createElement(Button, { variant: "secondary", onClick: function () {
                            setStartDate(null);
                            setEndDate(null);
                        } }, "Clear")))))));
};
